export default __webpack_public_path__ + "static/media/pipelines-md5.725b1327.svg";